import {
  ORDER_HISTORY_FILTERS_UPDATE_DATE_RANGE,
  UPDATE_ORDER_HISTORY_ALERT,
  CLEAR_PAGE_DATA, CLEAR_REPORTS_DATA,
  AVAILABLE_REPORT_ACTIONS_SUCCESS,
  ORDER_HISTORY_REPORT_FILE_TYPES_SUCCESS,
  ORDER_HISTORY_PROPERTY_DATA_LOADING,
  ORDER_HISTORY_PROPERTY_DATA_SUCCESS,
  ORDER_HISTORY_PROPERTY_DATA_ERROR,
  LOAD_ORDER_HISTORY_ERROR,
  SET_PAGE_OPTIONS, REPORT_DETAILS_NOT_FOUND,
  ORDER_HISTORY_REPORT_DETAILS_SUCCESS,
  ORDER_HISTORY_SUBSCRIPTION_DETAILS_SUCCESS,
  ORDER_HISTORY_REPORT_IDS_SUCCESS, LOADED_ORDER_HISTORY_REPORTS, LOADING_ORDER_HISTORY_REPORTS,
  UPDATE_SEARCH_TEXT, RESET_ORDER_HISTORY_LOAD_ERROR,
  ORDER_HISTORY_FILTERS_UPDATE_ORG_NODES_LIST,
  ORDER_HISTORY_SET_APPLIED_FILTERS,
  ORDER_HISTORY_RESET_FILTERS,
  ORDER_HISTORY_FILTERS_UPDATE_PRODUCTS_LIST,
  ORDER_HISTORY_FILTERS_UPDATE_STATUS_LIST,
} from 'constants/ActionTypes';
import { DATE_RANGES, getLastYearRange, isDateRangeValid } from './components/filters/commonComponents/dateRangeFilter/DateFilter.utils';

const initPageData = {
  reportDetails: null,
  fileTypes: {},
  availableActions: {},
  propertyDataMap: {},
  subscriptionDetailsMap: {},
  loadingPropertyData: false,
};

const [defaultStartDate, defaultEndDate] = getLastYearRange();

const initOrderHistoryFilters = {
  orgNodeList: [],
  dateError: false,
  selectedDateOption: DATE_RANGES.LAST_YEAR,
  startDate: defaultStartDate,
  endDate: defaultEndDate,
  productIds: [],
  statusList: [],
};

const initAppliedFilters = {
  orgNodeList: [],
  selectedDateOption: DATE_RANGES.LAST_YEAR,
  startDate: defaultStartDate,
  endDate: defaultEndDate,
  productIds: [],
  statusList: [],
};

const initState = {
  reportIds: null,
  pageNumber: 1,
  pageSize: 10,
  loading: true,
  closureReasons: [],
  cancelReportID: null,
  searchText: '',
  loadError: false,
  notFound: false,
  orderHistoryAlert: {
    open: false,
    severity: '',
    title: '',
    message: '',
  },
  ...initPageData,
  orderHistoryFilters: initOrderHistoryFilters,
  orderHistoryAppliedFilters: initAppliedFilters,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case LOADING_ORDER_HISTORY_REPORTS: return { ...state, loading: true };
    case LOADED_ORDER_HISTORY_REPORTS: return { ...state, loading: false, loadError: false };
    case LOAD_ORDER_HISTORY_ERROR: return { ...state, loading: false, loadError: true };
    case ORDER_HISTORY_REPORT_IDS_SUCCESS: return { ...state, reportIds: action.reportIds };
    case ORDER_HISTORY_REPORT_DETAILS_SUCCESS: return { ...state, reportDetails: action.reportDetails, loadError: false };
    case ORDER_HISTORY_SUBSCRIPTION_DETAILS_SUCCESS: return { ...state, subscriptionDetailsMap: action.subscriptionDetailsMap };
    case SET_PAGE_OPTIONS: return { ...state, ...action.pageOptions };
    case ORDER_HISTORY_REPORT_FILE_TYPES_SUCCESS: return { ...state, fileTypes: action.fileTypes };
    case ORDER_HISTORY_PROPERTY_DATA_LOADING: return { ...state, loadingPropertyData: true };
    case ORDER_HISTORY_PROPERTY_DATA_SUCCESS: return { ...state, propertyDataMap: action.propertyDataMap, loadingPropertyData: false };
    case ORDER_HISTORY_PROPERTY_DATA_ERROR: return { ...state, loadingPropertyData: false };
    case AVAILABLE_REPORT_ACTIONS_SUCCESS: return { ...state, availableActions: action.availableActions };
    case CLEAR_PAGE_DATA: return { ...state, ...initPageData };
    case CLEAR_REPORTS_DATA: return { ...state, ...initPageData, reportIds: null };
    case UPDATE_SEARCH_TEXT: return { ...state, searchText: action.searchText };
    case RESET_ORDER_HISTORY_LOAD_ERROR: return { ...state, loadError: false, notFound: false };
    case REPORT_DETAILS_NOT_FOUND: return { ...state, notFound: true };
    case UPDATE_ORDER_HISTORY_ALERT: return {
      ...state,
      orderHistoryAlert: action.orderHistoryAlert,
    };
    case ORDER_HISTORY_FILTERS_UPDATE_ORG_NODES_LIST: return {
      ...state,
      orderHistoryFilters: { ...state.orderHistoryFilters, orgNodeList: action.updatedOrgNodeList },
    };
    case ORDER_HISTORY_FILTERS_UPDATE_DATE_RANGE: {
      const startDate = action.startDate ?? state.orderHistoryFilters.startDate;
      const endDate = action.endDate ?? state.orderHistoryFilters.endDate;

      const dateError = isDateRangeValid(startDate, endDate);
      return {
        ...state,
        orderHistoryFilters: {
          ...state.orderHistoryFilters,
          startDate,
          endDate,
          dateError,
          selectedDateOption: action.selectedDateOption,
        },
      };
    }
    case ORDER_HISTORY_SET_APPLIED_FILTERS: return {
      ...state,
      orderHistoryAppliedFilters: state.orderHistoryFilters,
    };
    case ORDER_HISTORY_RESET_FILTERS: return {
      ...state,
      orderHistoryFilters: initOrderHistoryFilters,
      orderHistoryAppliedFilters: initAppliedFilters,
    };
    case ORDER_HISTORY_FILTERS_UPDATE_PRODUCTS_LIST: return {
      ...state,
      orderHistoryFilters: {
        ...state.orderHistoryFilters,
        productIds: action.productsList,
      },
    };
    case ORDER_HISTORY_FILTERS_UPDATE_STATUS_LIST: return {
      ...state,
      orderHistoryFilters: {
        ...state.orderHistoryFilters,
        statusList: action.statusList,
      },
    };
    default: return state;
  }
};
